import { XpressOffenseType } from 'app/models';

export class XpressOffenseTypeModel {
    public static XpressOffenseTypeList: Array<any> = [
        { name: 'Rude', value: XpressOffenseType.Rude },
        { name: 'No Show', value: XpressOffenseType.NoShow },
        { name: 'Dangerous Driving', value: XpressOffenseType.DangerousDriving }
    ];
}
